import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, of, switchMap } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { Roles } from 'src/app/shared/services/names.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
 url = `${environment.domain}/api/data/v9.2/adca_InvokeCRM`
  constructor(private http:HttpClient,     private msalService: MsalService,
    ) { 
  }

  private userRolesSubject = "";
  private setUserRoles(roles): void {
    const  appRoles = roles.filter((x) => (x.securityRoleName === Roles.mktUser || x.securityRoleName === Roles.cprUser))
    if(appRoles.length === 2){
      this.userRolesSubject = Roles.adminUser
    }else if(appRoles.length === 1){
      this.userRolesSubject = appRoles[0].securityRoleName
    }
  }

  getUserRoles(){

    if(this.userRolesSubject)
    return this.userRolesSubject
    else{
      const uniqueId = localStorage.getItem("uniqueId")
      const userString = localStorage.getItem('loggedinUser')
      let userDetails = userString ? JSON.parse(userString) : null
  
      return new Promise(resolve => {
        this.getUserDetails(uniqueId).pipe(switchMap((res) => of(res) )) .subscribe((response:any) => {
          if (response.ResponseCode === "200") {
            const res = JSON.parse(response.ResponseMessage)
            userDetails.arabicName = res.arabicName
            localStorage.setItem('loggedinUser', JSON.stringify(userDetails))
            const securityRoles = res.securityRoles
            this.setUserRoles(securityRoles)            
         resolve(this.userRolesSubject) 
          }else{
            resolve("") 
          }
        })
      }) 
    }

  }

  getUserDetails(objectId:string){
    const body = {"ActionName":"Get User Details","RequestJSON": JSON.stringify({azureActiveDirectoryObjectId:objectId}) }
    return this.http.post(this.url,body)
  }

}


